import { Navigate } from 'react-router';
import { inferRouteObject } from 'react-router-typed-object';

import { PrivateRoute, Roles } from '@/js/libs/use-auth';

import Status from 'src/scenes/Status';
import { SupportCenter } from 'src/scenes/SupportCenter';

const index = true;

export const supportCenterRouteObject = inferRouteObject({
  path: 'support-center',
  element: <PrivateRoute roles={Roles.SUPPORT_CENTER} noAccessComponent={Status.NotFound} />,
  children: [
    {
      path: 'tickets',
      children: [
        {
          index,
          Component: SupportCenter.Tickets,
        },
        {
          path: 'create',
          Component: SupportCenter.TicketForm,
        },
        {
          path: ':ticketId',
          children: [
            {
              index,
              Component: SupportCenter.TicketOverview,
            },
            {
              path: 'edit',
              Component: SupportCenter.TicketForm,
            },
          ],
        },
      ],
    },
    {
      index,
      element: <Navigate to='tickets' replace />,
    },
  ],
});
